import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Image from 'react-bootstrap/lib/Image';
import cx from 'classnames';

import messages from '../../locale/messages';
import showToaster from '../../helpers/showToaster';

import googleIcon from '/public/SiteIcons/googleSign.svg';

import s from './SocialLogin.css';
const SocialLogin = ({ refer }) => {

  const isAdmin = useSelector(state => state.runtime && state.runtime.isAdminAuthenticated);

  const handleClick = (event) => {
    if (isAdmin) {
      showToaster({ messageId: 'isAdmin', toasterType: 'error' })
      event.preventDefault();
    }
  };

  let GoogleURL = '/login/google';
  if (refer) GoogleURL = '/login/google?refer=' + refer;

  return (
    <div className={cx(s.bgColor, 'googleIconRTL')}>
      <a className={cx(s.displayFlexIcon, s.button)} onClick={(event) => handleClick(event)} href={GoogleURL}>
        <Image src={googleIcon} responsive />
        <span><FormattedMessage {...messages.google} /></span>
      </a>
    </div>
  );
}

SocialLogin.propTypes = {
  formatMessage: PropTypes.any,
  refer: PropTypes.string
};

export default withStyles(s)(SocialLogin);